import useFunction from "../../hooks/useFunction";
import useApi from "../../api/useApi";

const useBookingService = () => {

  const {api} = useApi()
  const {getIDsArray} = useFunction()

  const userShow = (callbackSuccess, callbackValidationErrors, bookingId) => {
    return api(
      'get',
      'user/booking/' + bookingId,
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useBookingService::userShow: ${error?.message || JSON.stringify(error)}`)},
    )
  }

  const userShowFilterCollection = (callbackSuccess, callbackValidationErrors, startDate, endDate) => {
    return api(
      'post',
      'user/bookings/range-bookings',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useBookingService::userShowFilterCollection: ${error?.message || JSON.stringify(error)}`)},
      {
        start_date: startDate,
        end_date: endDate,
      },
    )
  }

  const userUpdate = (callbackSuccess, callbackValidationErrors, bookingId, booking) => {
    return api(
      'post',
      'user/booking/' + bookingId + '/update',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useBookingService::userUpdate: ${error?.message || JSON.stringify(error)}`)},
      booking,
    )
  }

  const userAction = (callbackSuccess, callbackValidationErrors, bookingId, action) => {
    return api(
      'post',
      'user/booking/' + bookingId + '/action',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useBookingService::userAction: ${error?.message || JSON.stringify(error)}`)},
      action,
    )
  }

  const userStore = (callbackSuccess, callbackValidationErrors, booking) => {
    return api(
      'post',
      'user/booking/store',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useBookingService::userStore: ${error?.message || JSON.stringify(error)}`)},
      booking,
    )
  }

  const preService = (booking) => {

    /*
     * Remove props from booking,
     *
     * //todo this might cause problems, e.g. updateWizard steps function might need these vars.
     *
     */

    if ('spot_group' in booking && booking.spot_group){
      booking.spot_group.spots = null
      booking.spot_group.spot_clusters = null
      booking.spot_group.spot_maps = null
    }

    // booking.stand = null
    // booking.prices = {
    //   booking: {},
    //   spot: [],
    //   booking_options: [],
    // }

    /*
     * Add props to booking
     */
    return {
      ...booking,
      spots_ids: getIDsArray(booking.spots),
    }
  }

  return {
    objectType: 'booking',
    userShow,
    userShowFilterCollection,
    userUpdate,
    userStore,
    preService,
    userAction,
  }
}

export default useBookingService
